import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/design-system.css';

const FloatingWhatsApp = () => {
  const { contactData } = useLanguage();
  const whatsappNumber = contactData.whatsapp.replace(/\D/g, '');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=Olá! Gostaria de mais informações sobre os serviços da Lucimar Bizoni.`;

  return (
    <div className="fixed bottom-6 right-4 sm:right-6 z-50">
      <motion.a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover-scale block text-white text-decoration-none"
        style={{ background: '#25D366' }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <MessageCircle size={32} color="white" />
      </motion.a>

      <motion.div
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{ background: '#25D366' }}
        animate={{
          scale: [1, 1.4, 1.4],
          opacity: [0.5, 0, 0]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeOut"
        }}
      />
    </div>
  );
};

export default FloatingWhatsApp;
